"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var baseStyles_exports = {};
__export(baseStyles_exports, {
  baseStyles: () => baseStyles
});
module.exports = __toCommonJS(baseStyles_exports);
const baseStyles = {
  terrain: {
    url: "mapbox://styles/cartographerio/ck48momyg4af61cmm8gtced56",
    insertBefore: "waterway-label"
  },
  satellite: {
    url: "mapbox://styles/cartographerio/ck48o09mu06mw1cmycjkzd4e9",
    insertBefore: "waterway-label"
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  baseStyles
});
//# sourceMappingURL=baseStyles.js.map
